var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Monogram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dweb",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monogram",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C24.209139,-4.05812251e-16 26,1.790861 26,4 L26,22 C26,24.209139 24.209139,26 22,26 L4,26 C1.790861,26 2.705415e-16,24.209139 0,22 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L22,0 Z M9.41736695,5.86666667 L4.3535014,5.86666667 L4.3535014,6.16014109 L5.98437597,8.12478933 C6.14448,8.26909747 6.22624504,8.48102096 6.20454404,8.69543405 L6.20454404,8.69543405 L6.20454404,16.4154419 C6.25205117,16.6939313 6.16426161,16.9784101 5.96806723,17.1817363 L5.96806723,17.1817363 L4.13333333,19.4072507 L4.13333333,19.7007251 L9.33582321,19.7007251 L9.33582321,19.4072507 L7.50108932,17.1817363 C7.30345599,16.9787467 7.21023037,16.6961425 7.24830376,16.4154419 L7.24830376,16.4154419 L7.24830376,9.73889869 L11.8147526,19.7007251 L12.3447868,19.7007251 L16.2670401,9.73889869 L16.2670401,17.6790124 C16.2670401,17.8909661 16.2670401,17.9317264 16.1284159,18.0703116 L16.1284159,18.0703116 L14.7177093,19.4398589 L14.7177093,19.7333333 L21.5673825,19.7333333 L21.5673825,19.4398589 L20.2056023,18.1029199 C20.0853899,18.0112869 20.0257584,17.8606819 20.0506692,17.7116207 L20.0506692,17.7116207 L20.0506692,7.88837939 C20.0257584,7.73931816 20.0853899,7.58871303 20.2056023,7.49708015 L20.2056023,7.49708015 L21.6,6.16014109 L21.6,5.86666667 L16.7726113,5.86666667 L13.3314659,14.4507936 L9.41736695,5.86666667 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8f43491e682ec7cd14f910820bd2bf35.svg";
export { ForwardRef as ReactComponent };